import { useEffect } from 'react';
import styled from 'styled-components';
import Loader from 'components/Loader';
import useComAIStore, { useInitializeChat, useIsComAILoading } from '../store/comAIStore';
import Disclaimer from './Disclaimer';
import Messages from './Messages';
import ObserverScrollContainer from './ObserverScrollContainer';

const Wrapper = styled.div`
    flex: 1 1 auto;
    padding: ${({ theme }) => theme.Spacing20} ${({ theme }) => theme.Spacing16};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.Spacing16};
`;

const StyledLoader = styled(Loader)`
    opacity: 1;
    transition: opacity 1000ms ease-out;

    @starting-style {
        opacity: 0;
    }
`;

export default function Content() {
    const init = useInitializeChat();
    const showDisclaimer = useComAIStore((state) => state.showDisclaimer);
    const isLoading = useIsComAILoading();

    useEffect(() => {
        async function initChat() {
            await init();
        }

        initChat();

        return () => {
            useComAIStore.getState().clearChat();
        };
    }, []);

    return (
        <ObserverScrollContainer>
            <Wrapper>
                {showDisclaimer && <Disclaimer />}
                <Messages />
                {isLoading && <StyledLoader />}
            </Wrapper>
        </ObserverScrollContainer>
    );
}
